import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Patient } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ARCHIVED_PATIENTS_IN_ORG_KEY = 'get-archived-patients-in-org';

export const useGetArchivedPatientsInOrg = (
  orgId: number,
  { page = 0, size = 1000 }: UseGetAllPageSizeProps,
) => {
  return usePermittedQuery<Patient[]>(
    [ACCOUNT_TYPE.ADMIN],
    () => `/patient/archived/org/${orgId}?page=${page}&size=${size}`,
    {},
    [GET_ARCHIVED_PATIENTS_IN_ORG_KEY],
    {
      enabled: typeof orgId === 'number' && orgId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
